import styled from 'styled-components';
import {FieldErrorMessage} from '@chekinapp/ui';

export const InputWrapper = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InputBox = styled.input`
  width: 32px;
  height: 32px;
  border: 1px solid #777e91;
  border-radius: 6px;
  font-size: 1.5rem;
  text-align: center;
  outline: none;
  background: #fff;
  transition: border 0.2s, box-shadow 0.2s;
  box-shadow: none;
  color: #152946;
  padding: 0;

  &:focus {
    border: 2px solid #385bf8;
    box-shadow: 0 0 0 3px #385bf833;
  }

  @media (min-width: 400px) {
    width: 48px;
    height: 48px;
    font-size: 2rem;
  }
`;

export const ErrorMessage = styled(FieldErrorMessage)`
  font-family: inherit;
  text-align: left;
  color: #f84b7a;
  white-space: nowrap;
  font-size: 11px;
  margin-left: 12px;

  span:last-child {
    white-space: inherit;
  }
`;
